module.exports = __webpack_public_path__ + "static/img/xi_12.c78aeb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xi_12.png
// module id = 0leq
// module chunks = 1